// https://react.i18next.com/
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import spanishTranslation from 'src/translation/es.json'

i18n.use(initReactI18next).init({
  debug: false,
  fallbackLng: 'es',
  resources: {
    es: {
      translation: spanishTranslation
    }
  }
})

export default i18n
